var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button-loader",
    {
      staticClass: "mr-2",
      attrs: { loading: _vm.loading, "show-custom-color": "" },
    },
    [
      _c(
        "b-dropdown",
        {
          staticClass: "dropdown-responsive",
          attrs: { id: "boards-actions-dropdown", variant: "white btn-sm" },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c("span", { staticClass: "d-none d-lg-inline" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.actions"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "i",
                    { staticClass: "material-icons d-inline d-lg-none" },
                    [_vm._v("more_vert")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSelection("create-column")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.actions.addNewStatus")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("b-dropdown-divider"),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSelection("create")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.actions.createNewBoard")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSelection("duplicate")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.actions.createDuplicateBoard")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isOwner
            ? _c(
                "b-dropdown-item",
                {
                  staticClass: "pendo--edit-board-name",
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("edit")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("boards.actions.editBoardName")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isOwner
            ? _c(
                "b-dropdown-item",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.left",
                      value: {
                        title: _vm.$t(
                          "boards.messages.defaultBoardCannotBeDeleted"
                        ),
                        disabled: !_vm.isDefaultBoard,
                        boundary: "#boards-actions-dropdown",
                      },
                      expression:
                        "{\n        title: $t('boards.messages.defaultBoardCannotBeDeleted'),\n        disabled: !isDefaultBoard,\n        boundary: '#boards-actions-dropdown'\n      }",
                      modifiers: { hover: true, left: true },
                    },
                  ],
                  attrs: { "link-class": { disabled: _vm.isDefaultBoard } },
                },
                [
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleSelection("delete")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("boards.actions.deleteCurrentBoard")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isOwner
            ? _c(
                "b-dropdown-item",
                { attrs: { disabled: _vm.isDefaultBoard } },
                [
                  _vm.isDefaultBoard
                    ? _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("boards.actions.currentBoardDefault")
                            ) +
                            "\n      "
                        ),
                      ])
                    : _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.handleSelection("set-default")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t("boards.actions.setCurrentBoardDefault")
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSelection("changelog-summary")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.changelog.changelogSummary")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("b-dropdown-divider"),
          _vm._v(" "),
          _vm.isOwner
            ? _c(
                "b-dropdown-item",
                {
                  staticClass: "pendo--add-edit-collaborators",
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("manage-collaborators")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("boards.actions.manageCollaborators")) +
                      "\n    "
                  ),
                ]
              )
            : _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("remove-as-collaborator")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("boards.actions.removeAsCollaborator")) +
                      "\n    "
                  ),
                ]
              ),
          _vm._v(" "),
          _vm.isOwner && _vm.showEditBoard
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("manage-visibility")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("boards.actions.manageVisibility")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-dropdown-divider"),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              attrs: {
                "link-class": "d-flex flex-row align-items-center clickable",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.handleSelection("toggle-email-tracking", {
                    trackEmails: _vm.trackEmails,
                  })
                },
              },
            },
            [
              _c("p", { staticClass: "mb-0 w-auto pr-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("boards.actions.emailTrackingDefault")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pretty pb-1 p-switch p-fill" }, [
                _c("input", {
                  attrs: {
                    id: "board-collaborator-track-emails",
                    type: "checkbox",
                  },
                  domProps: { checked: _vm.trackEmails },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state" }, [
                  _c(
                    "label",
                    {
                      staticClass: "hidden-text text-light-gray",
                      attrs: { for: "board-collaborator-track-emails" },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleSelection("export-csv")
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.actions.exportCSV")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("b-dropdown-divider", { staticClass: "d-block d-lg-none" }),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              staticClass: "d-block d-lg-none",
              on: {
                click: function ($event) {
                  return _vm.showCreateClient()
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.actions.createNewClient")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("b-dropdown-divider", { staticClass: "d-none d-md-block" }),
          _vm._v(" "),
          _vm.boardView !== "classic"
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("toggle-view", {
                        boardView: "classic",
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("boards.actions.changeToView", {
                          view: _vm.$t("boards.views.list").toLowerCase(),
                        })
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.boardView !== "dynamic"
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("toggle-view", {
                        boardView: "dynamic",
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("boards.actions.changeToDynamicView")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.boardView !== "chart"
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleSelection("toggle-view", {
                        boardView: "chart",
                      })
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("boards.actions.changeToView", {
                          view: _vm.$t("boards.views.chart").toLowerCase(),
                        })
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }